export default "__VITE_ASSET__DxWVpHQh__"